// Copyright (c) 2020 Sagacity Solutions Inc. All right reserved.
'use strict';

import { Recipient } from '@/models';
import { defaultNotification } from "@/app.config";

function mergeReminders(reminders) {
  let r = [];
  if (Array.isArray(reminders)) {
    r.push(...reminders); 
  }
  return r;
}

function addUserNotification(patient, messageType, user, language) {
  let reminders = mergeReminders(patient.Reminders);

  let notifications = selectDefaultNotification(messageType, language);
  notifications.forEach((r) => {
    let tr = Object.assign({"MessageType": "Monitoring Only"}, r);
    tr.Recipients = [new Recipient(user, '', user)];
    reminders.push(tr);
  });
  patient.Reminders = reminders;
}

function addNotification(patient, messageType) {
  let reminders = mergeReminders(patient.Reminders);
  let notifications = selectDefaultNotification(messageType, patient.Language);
  notifications.forEach((r) => {
    let recipients = [];

    if (patient.Email !== '') {
      recipients.push(new Recipient(patient.Name, '', patient.Email));
    }

    if (patient.Phone !== '') {
      recipients.push(new Recipient(patient.Name, patient.Phone));
    }

    let tr = Object.assign({}, r, {MessageType: messageType});
    tr.Recipients = recipients;
    reminders.push(tr);
  });
  patient.Reminders = reminders;
}

function selectDefaultNotification(type, lang) {
  let nt = defaultNotification[type];
  if (nt === undefined)
    return [];

  return nt[lang] || []
}

function getNotficationType() {
  return Object.keys(defaultNotification);
}

function messageTypeExist(messageType, list) {
  return list.some(element => messageType === element.MessageType)
}

function removeMessageTypeFromList(messageType, reminder) {
  return reminder.filter(r => r.MessageType !== messageType)
}

export {
  addUserNotification,
  addNotification,
  selectDefaultNotification,
  getNotficationType,
  messageTypeExist,
  removeMessageTypeFromList,
}
